import * as XLSX from "xlsx";

/**
 * Saves rows (array of plain objects; keys = column headers, in order) as an .xlsx file.
 * Column widths follow the longest header/value (capped), so the sheet opens readable.
 * Same xlsx approach as the hotel reports; use this instead of repeating it.
 */
export function downloadExcel(rows, fileName, sheetName = "Sheet1") {
  downloadExcelSheets([{ name: sheetName, rows }], fileName);
}

/** Same as downloadExcel, with one sheet per entry of sheets: [{ name, rows }] (in order). */
export function downloadExcelSheets(sheets, fileName) {
  const workbook = XLSX.utils.book_new();
  sheets.forEach(({ name, rows }) => {
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const headers = rows.length ? Object.keys(rows[0]) : [];
    worksheet["!cols"] = headers.map((header) => ({
      wch: Math.min(
        60,
        Math.max(header.length, ...rows.map((row) => String(row[header] ?? "").length)) + 2,
      ),
    }));
    XLSX.utils.book_append_sheet(workbook, worksheet, name.slice(0, 31)); // Excel sheet-name limit
  });
  XLSX.writeFile(workbook, fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`);
}

/** File-name safe text: spaces to "_", drops characters Windows does not allow. */
export const safeFileName = (text) =>
  String(text ?? "")
    .trim()
    .replace(/[\\/:*?"<>|]+/g, "")
    .replace(/\s+/g, "_");
